import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { injectIntl } from '../../util/reactIntl';
import { alertModalService } from '../../services/services';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routing/routeConfiguration';

import { PrimaryButton } from '../../components';

import css from './VerifyPhonePrompt.module.scss';

const VerifyPhonePromptComp = (props) => {
  const {
    history,
  } = props;

  const handleClick = () => {
    alertModalService.closeModal();
    history.push(createResourceLocatorString(
      'ContactDetailsPage',
      routeConfiguration(),
      {},
      {}
    ));
  };

  return (
    <div className={css.root}>
      <p className={css.text}>Please verify your phone number</p>
      <PrimaryButton
        className={css.button}
        onClick={handleClick}
      >
        Verify
      </PrimaryButton>
    </div>
  );
};

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

const VerifyPhonePrompt = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(VerifyPhonePromptComp);

export default VerifyPhonePrompt;
